import ResourceModel from "models/convention-api/ResourceModel"

export default class ActiveVisitorCount extends ResourceModel {
  protected static basePath = "/v1/convention_providers/:provider_id/active_visitor_counts"

  convention_convention_id!: string
  count!: number
}
